var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-432.000000, -377.000000)",
    fill: "#1DBADF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(421.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1568186,1 C1.9622767,1 1,1.96564058 1,3.1568186 L1,12.8431814 C1,14.0377233 1.96564058,15 3.1568186,15 L12.8431814,15 C14.0377233,15 15,14.0343594 15,12.8431814 L15,3.1568186 C15,1.9622767 14.0343594,1 12.8431814,1 L12.2487915,1 L11.5204224,2.41751709 L12.2487915,2.41751709 C12.8466241,2.41751709 13.6116211,3.23480239 13.6116211,3.8331543 L13.6116211,12.2566528 C13.6116211,12.8544854 12.8471434,13.6129883 12.2487915,13.6129883 L3.82127686,13.6129883 C3.22344428,13.6129883 2.43554688,12.8550047 2.43554688,12.2566528 L2.43554688,3.8331543 C2.43554688,3.23532172 3.22292495,2.41751709 3.82127686,2.41751709 L6.59632568,2.41751709 L7.36989746,1 L3.1568186,1 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59534926,13.2444738 L4.42300473,9.13907535 L9.02502306,1.05932617 L11.0347401,1.05932617 L6.06667381,9.68598604 L6.00138969,10.9203037 L7.08838842,10.2013582 L11.0017676,3.98059082 L11.0017676,3.98059082 C11.5356824,3.98059082 11.9685059,4.43095331 11.9685059,4.97629019 L11.9685059,5.5670166 L8.25390902,11.5685358 L4.59534926,13.2444738 Z",
    fillRule: "evenodd"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.01fb17d5.svg";
export { ForwardRef as ReactComponent };